// Imports
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".root {\n  --inputDatePicker-input-padding: 11px 11px 9px;\n}\n", "",{"version":3,"sources":["webpack://src/toggle-auto-variables.css"],"names":[],"mappings":"AAAA;EACE,8CAA8C;AAChD","sourcesContent":[".root {\n  --inputDatePicker-input-padding: 11px 11px 9px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
